import { render, staticRenderFns } from "./PickUpRecordDetail.vue?vue&type=template&id=946da512&scoped=true&"
import script from "./PickUpRecordDetail.vue?vue&type=script&lang=js&"
export * from "./PickUpRecordDetail.vue?vue&type=script&lang=js&"
import style0 from "./PickUpRecordDetail.vue?vue&type=style&index=0&id=946da512&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "946da512",
  null
  
)

export default component.exports